export default defineNuxtPlugin(() => {
  const langStore = useLanguageStore()
  const { currentLocaleCode } = useLanguage()
  const dayjs = useDayjs()
  return {
    provide: {
      currencyFormat: (number: number, digit: number = 0): string => {
        return number ? number.toFixed(digit).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : '0'
      },
      shortDateFormat: (dateTime: string): string => {
        const localeCode = currentLocaleCode.value || langStore.main.code || 'th'
        const date = dayjs.utc(dateTime).locale(localeCode)
        if (localeCode === 'th') {
          return date.format('DD MMM BBBB')
        }
        return date.format('DD MMM YYYY')
      },
      phoneNumberFormat: (phoneNumber: string, intermediate: string = '-'): string => {
        const currentTelephoneNumber = phoneNumber.toString().replace(/[^0-9]+/g, '')
        return `${currentTelephoneNumber.slice(0, 3)}${currentTelephoneNumber.length > 3 ? intermediate : ''
          }${currentTelephoneNumber.slice(3, 6)}${currentTelephoneNumber.length > 6 ? intermediate : ''
          }${currentTelephoneNumber.slice(6)}`
      },
    },
  }
})
